




















import {
  Vue,
  Component,
  Model,
  Prop,
  Emit,
  Watch,
} from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import { LineItem } from "@/models/campaign";
import AdUnit from "@/models/adUnit";
import Site from "@/models/site";
import { DefinitionBatch } from "@/models/definition";
import { get } from "lodash";
import DefinitionValue from "@/models/definitionValue";
import moment from "moment";
@Component({
  components: { DatePicker },
})
export default class CampaignReportFilter extends Vue {
  @Prop() loading!: boolean;
  @Prop() minDate!: string;
  @Prop() maxDate!: string;
  @Prop() dateRange!: string[];
  @Prop() lineItems!: LineItem[];
  @Prop() definitions!: DefinitionBatch[];
  @Prop() sites!: Site[];
  @Prop() adUnits!: AdUnit[];

  range: string[] = [];
  lineItem: LineItem | null = null;

  created(): void {
    if (this.range.length === 0) {
      this.range = this.dateRange;
    }
  }

  @Watch("range")
  updateRange(): void {
    if (this.range.length > 1) {
      this.$emit("change", this.range);
    }
  }

  getReport(): void {
    this.$emit("getReport");
  }

  getSite(id: string): string {
    const site = this.sites.find((e) => e.id === id);
    return site ? site.name : "";
  }

  getAdUnit(id: string): string {
    const adUnit = this.adUnits.find((e) => e.id === id);

    return adUnit ? adUnit?.name : "";
  }

  getDefinition(id: string): string {
    let definition;
    this.definitions.forEach((e) => {
      const value = e.values.find((d) => get(d, "id") === id);
      value ? (definition = value) : null;
    });
    return definition ? get(definition, "name") : "";
  }

  onSelect(lineItem: LineItem): void {
    this.lineItem = lineItem;
  }
}
